module.exports = __webpack_public_path__ + "img/Map.ec26e692.svg";